import IconChevronDown from '@/assets/icons/font_awesome/chevron-down-solid.svg?react';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { UI_PRIMITIVE__dropdown_menu } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu';
import { UI_PRIMITIVE__dropdown_menu_content } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_content';
import { UI_PRIMITIVE__dropdown_menu_item } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_item';
import { UI_PRIMITIVE__dropdown_menu_trigger } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_trigger';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_debounced_function } from '@/hooks/debounce/use_debounced_function';
import { use_slice_ml_asset } from '@/hooks/store/use_slices';
import i18n_page_diffusion_models from '@/locales/keys/i18n_page_diffusion_models.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { local_ml_asset_set_current_table_page_settings } from '@/state/diffusion_models_ud/local_ml_asset_set_current_table_page_settings';
import { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { EPageDiffusionModelsFilterFloatPrecision } from '../../_base/enums/e_page_diffusion_models_filter_float_precision';

export function DiffusionModelsFilterDropdownFloatPrecisionUD() {
  const dispatch = use_dispatch();

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_DIFFUSION_MODELS);

  const { current_table_page_settings } = use_slice_ml_asset(['current_table_page_settings']);

  const [value_selected, set_value_selected] = useState('');

  const trigger_id = 'dropdown_diffusion_models_filter_float_precision_ud';

  /*
   * EVENTS
   */
  async function on_item_selected(value: string) {
    set_value_selected(value);

    try_set_float_precision_debounced(value);
  }

  /*
   * EFFECTS
   */

  /*
   * METHODS
   */

  function try_set_float_precision(value: string) {
    let filter_floating_point_precision = value === EPageDiffusionModelsFilterFloatPrecision.ALL ? '' : value;

    if (current_table_page_settings.filter_floating_point_precision == filter_floating_point_precision) return;

    let current_table_page_settings_new = current_table_page_settings.clone({ filter_floating_point_precision });

    dispatch(local_ml_asset_set_current_table_page_settings(current_table_page_settings_new));
  }

  let try_set_float_precision_debounced = use_debounced_function(try_set_float_precision, CONSTANTS_TIME__client.DEBOUNCE_LOAD_DIFFUSION_MODELS);

  /*
   * RENDERS
   */

  function render_items() {
    return Object.values(EPageDiffusionModelsFilterFloatPrecision).map(value => {
      return (
        <UI_PRIMITIVE__dropdown_menu_item
          key={value}
          className={`settings-dropdown-item text-page-foreground`}
          class_name_hovered_selected={`bg-component-item`}
          label={value}
          values_selected={[value_selected]}
          {...{ on_item_selected, value }}
        />
      );
    });
  }

  /*
   * HTML
   */

  return (
    <div className="w-full px-2">
      <UI_PRIMITIVE__dropdown_menu>
        <UI_PRIMITIVE__dropdown_menu_trigger asChild>
          <UI_PRIMITIVE__button id={trigger_id} className="settings-dropdown-button bg-bar w-full text-page-foreground" variant="outline-on-component" disabled>
            {t(i18n_page_diffusion_models.dropdown.float_precision.title)}: {value_selected}
            <IconChevronDown className="!w-3 !h-3" />
          </UI_PRIMITIVE__button>
        </UI_PRIMITIVE__dropdown_menu_trigger>
        <UI_PRIMITIVE__dropdown_menu_content trigger_id={trigger_id} className="rounded-lg">
          {render_items()}
        </UI_PRIMITIVE__dropdown_menu_content>
      </UI_PRIMITIVE__dropdown_menu>
    </div>
  );
}
